import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '../icons/InfoIcon';
import { FontPreviewContent } from '../ModalContent';
import { RitBlockButtons, FontColorButton } from '../RitBlockButton';
import RitModal from '../RitModal';

const FontComponent = (options) => {
    let type = null
    if (options.meta.valid) {
        type = "success"
    } else if (options.meta.visited) {
        type = "error"
    }

    const [activeEnum, setactiveEnum] = useState(options.input.value);
    const [isModalOpened, setIsModalOpened] = useState(false);

    const onChange = (value) => {
        setactiveEnum(value);
        options.input.onChange(value)
    }

    const toggleModal = () => {
        setIsModalOpened(!isModalOpened);
    }

    return (
        <div
            className='b-rit-form-group form-group--relative'
            label={options.label}
        >
            <br />
            <div className='b-rit-form-group__about'>
                <InfoIcon onClick={toggleModal} />
            </div>

            <p className='b-rit-form-group__title'>{options.displayName}</p>
            <div className='b-rit-list'>
                {options.values.map((item, i) => {
                    return (
                        <RitBlockButtons
                            key={i}
                            value={item.attrValue}
                            onChange={onChange}
                            themeClass={'item-theme--font'}
                            checked={item.attrValue == activeEnum}
                            showLabel={true}
                            displayName={item.shortName}
                        >
                            <FontColorButton
                                fontFamily={item.attrValue}
                                displayName={item.displayName}
                            />
                        </RitBlockButtons>
                    )
                })}
            </div>
            <RitModal
                isOpened={isModalOpened}
                onClose={toggleModal}
                title='Стили монограммы'
                closeOnEsc={true}
            >
                <FontPreviewContent items={options.values} />
            </RitModal>
        </div>
    )
}

FontComponent.propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    displayName: PropTypes.string,
    values: PropTypes.array.isRequired,
}

export default FontComponent;